import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { makeStyles } from '@material-ui/core'
import { COLORES } from '../../../../config/colores'

const useStyles = makeStyles(() => ({
  containerEstado: {
    width: '100%',
    backgroundColor: '#f8fafc',
    borderRadius: '12px',
    fontFamily: 'sans-serif',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
  },
  cardCantidad: {
    border: '1px solid #bbbbbb82',
    borderRadius: '8px',
    padding: '5px 18px',
    display: 'flex',
    flexDirection: 'column'
  },
  labelCantidad: {
    display: 'block',
    fontSize: '12px',
    fontWeight: 500,
    color: COLORES.blue.dark
  },
  boxCantidad: {
    display: 'block',
    fontSize: '20px',
    fontWeight: 700,
    color: COLORES.grey.dark,
    marginTop: '2px'
  },
  boxCantidadPlaya: {
    color: COLORES.blue.primaryDark
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  rowItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 8px'
  },
  labelConPunto: {
    color: '#475569',
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  },
  puntoIndicador: {
    height: '8px',
    width: '8px',
    borderRadius: '50%',
    backgroundColor: COLORES.green.medium
  },
  valorDestacado: {
    fontWeight: 600,
    color: COLORES.grey.dark
  },
  rowItemDestacado: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '14px',
    backgroundColor: '#eff6ff',
    padding: '10px',
    borderRadius: '8px'
  },
  labelDestacado: {
    fontWeight: 500,
    color: COLORES.blue.primaryDark
  },
  numeroDestacado: {
    fontWeight: 700,
    color: COLORES.blue.primary
  }
}))

export function EstadoCerealParaPedido (props) {
  const { cerealSeleccionado } = props
  const classes = useStyles()

  if (!cerealSeleccionado) return null

  const restanPedirPlaya = cerealSeleccionado.cantidad - cerealSeleccionado.pedidosRealizados
  const restanPedirAutorizados = cerealSeleccionado.autorizados - cerealSeleccionado.pedidosRealizados

  console.log('cantidadSiloAparteAutorizado ', cerealSeleccionado.cantidadSiloAparteAutorizado)

  return (
    <div
      className={classes.containerEstado}
      aria-label='Estado de disponibilidad del cereal seleccionado'
    >
      <Row>
        <Col xs={6} md={6}>
          <div className={classes.cardCantidad}>
            <span className={classes.labelCantidad}>Autorizados</span>
            <span className={classes.boxCantidad}>
              {cerealSeleccionado.autorizados || 0}
            </span>
            {cerealSeleccionado.cantidadSiloAparteAutorizado > 0 &&
            <small>(<span style={{ fontWeight: 600 }}>{cerealSeleccionado.cantidadSiloAparteAutorizado}</span> descargan silo aparte)</small>
            }
          </div>
        </Col>
        <Col xs={6} md={6}>
          <div className={classes.cardCantidad}>
            <span className={classes.labelCantidad}>Total en playa</span>
            <span className={`${classes.boxCantidad} ${classes.boxCantidadPlaya}`}>
              {cerealSeleccionado.cantidad || 0}
            </span>
          </div>
        </Col>
      </Row>

      <div className={classes.listContainer}>
        <div className={classes.rowItem} style={{ fontSize: '14px', marginTop: '5px' }}>
          <span className={classes.labelConPunto}>
            <span className={classes.puntoIndicador} />
                        Pedidos activos
          </span>
          <span className={classes.valorDestacado}>
            {cerealSeleccionado.pedidosRealizados || 0}
          </span>
        </div>
        <div className={classes.rowItemDestacado}>
          <span className={classes.labelDestacado}>
                        Restan pedir
          </span>
          <span className={classes.numeroDestacado}>
            <span style={{ color: COLORES.violet }}>{restanPedirAutorizados || 0} (autorizados)</span> - {restanPedirPlaya || 0} (pendientes en playa)
          </span>
        </div>
      </div>
    </div>
  )
}
